import React from 'react';
import { Paper, Typography, Grid, Box, Divider } from '@mui/material';
import DocumentComponent from 'components/shared/document_component';

// Mapeamentos para exibição dos selects/enums
const instrumentTypesMap: Record<string, string> = {
  'Lei municipal': 'Lei municipal',
  'Decreto': 'Decreto',
  'Portaria': 'Portaria',
  'Resolução': 'Resolução',
  'Instrução normativa': 'Instrução normativa',
  'Outro': 'Outro',
};

const statusMap: Record<string, string> = {
  'ativo': 'Ativo e atuante',
  'inativo': 'Inativo',
};

const structureMap: Record<string, string> = {
  'fixo': 'Mandato fixo',
  'rotativo': 'Mandato rotativo',
};

const InfoField: React.FC<{ label: string; value: React.ReactNode }> = ({ label, value }) => (
  <Box mb={1}>
    <Typography variant="subtitle1" fontWeight={600}>
      {label}
    </Typography>
    <Typography variant="body1">
      {value || 'Não informado'}
    </Typography>
  </Box>
);

interface Step1CmdrsViewProps {
  data: {
    hasCmdrs: boolean | null;
    instrument: string;
    instrumentNumber: string;
    publicationDate: string;
    document_uuid: string | null;
    status: string;
    structure: string;
    presidingInstitution: string;
    mandateEnd: string;
    qtdPoderPublico: number;
    qtdSociedadeCivil: number;
  };
}

const Step1CmdrsView: React.FC<Step1CmdrsViewProps> = ({ data }) => (
  <Paper elevation={1} sx={{ p: 3, mt: 2 }}>
    <Typography variant="h5" color="primary" gutterBottom>
      Informações Gerais do CMDRS
    </Typography>
    <Divider sx={{ mb: 3 }} />
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <InfoField
          label="O município possui CMDRS?"
          value={(() => {
            if (data.hasCmdrs === null) {
              return 'Não informado';
            } else {
              return data.hasCmdrs ? 'Sim' : 'Não';
            }
          })()}
        />
      </Grid>

      {data.hasCmdrs && (
        <>
          <Grid item xs={12} md={6}>
            <InfoField
              label="Tipo do Instrumento/Dispositivo Legal"
              value={instrumentTypesMap[data.instrument] || data.instrument || 'Não informado'}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <InfoField label="Número do instrumento" value={data.instrumentNumber} />
          </Grid>
          <Grid item xs={12} md={6}>
            <InfoField label="Data da publicação" value={data.publicationDate} />
          </Grid>
          <Grid item xs={12} md={6}>
            <InfoField
              label="Situação do CMDRS"
              value={statusMap[data.status] || data.status || 'Não informado'}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <InfoField
              label="Estrutura da diretoria"
              value={structureMap[data.structure] || data.structure || 'Não informado'}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <InfoField label="Nome da instituição que preside" value={data.presidingInstitution} />
          </Grid>
          <Grid item xs={12} md={6}>
            <InfoField label="Data de término do mandato" value={data.mandateEnd} />
          </Grid>
          <Grid item xs={12} md={6}>
            <InfoField label="Instituições do Poder público" value={data.qtdPoderPublico} />
          </Grid>
          <Grid item xs={12} md={6}>
            <InfoField label="Instituições da Sociedade civil" value={data.qtdSociedadeCivil} />
          </Grid>
          <Grid item xs={12} md={6}>
            <InfoField
              label="Documento"
              value={
                data.document_uuid ? (
                  <DocumentComponent
                    uuid={data.document_uuid}
                    podeEnviar={false}
                    podeSubstituir={false}
                    setUuid={() => { }}
                  />
                ) : (
                  'Não informado'
                )
              }
            />
          </Grid>
        </>
      )}
    </Grid>
  </Paper>
);

export default Step1CmdrsView;
